import styled from '@emotion/styled';
import type { EmotionScore } from '@hotjar/insights-common/constants/emotions';
import { imageIconBaseStyles } from '@hotjar/webapp/features/Feedback/EmotionIcon/icons/settings';

import emoji0 from '@hotjar/shared-assets/images/feedback/emoji_0.png';
import emoji1 from '@hotjar/shared-assets/images/feedback/emoji_1.png';
import emoji2 from '@hotjar/shared-assets/images/feedback/emoji_2.png';
import emoji3 from '@hotjar/shared-assets/images/feedback/emoji_3.png';
import emoji4 from '@hotjar/shared-assets/images/feedback/emoji_4.png';

const EMOTION_EMOJIS = [emoji0, emoji1, emoji2, emoji3, emoji4];

function getEmojiImageUrl(score: EmotionScore): string {
  return EMOTION_EMOJIS[score] ?? '';
}

export const EmojiIcon = styled.span<{ score: EmotionScore; size: number }>`
  ${imageIconBaseStyles}

  ${({ score }) => `
    background-image: url(${getEmojiImageUrl(score)});
  `}
`;
